var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"width":"40%","title":"驳回原因","destroy-on-close":"","visible":_vm.visible,"append-to-body":"","ok-text":"确认","cancel-text":"取消","footer":null},on:{"update:visible":function($event){_vm.visible=$event},"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_vm._v(" "+_vm._s(_vm.reasonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }